/** Domain service module: news.js */
import { request } from '../http/request'
import { API_BASE_URL } from './config'

class NewsService {
  list(urlParams, page) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/news?page=${page || 1}`, 'get', null, urlParams)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  myNews(urlParams, page) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/myNews?page=${page || 1}`, 'get', null, urlParams)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  create(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/news`, 'put', data)
        resolve(_result?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  update(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/news/${data?.id}`, 'patch', data)
        resolve(_result?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  delete(id) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/news/${id}`, 'delete')
        resolve(_result?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  view(id) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/news/view/${id}`, 'get')
        resolve(_result?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  startDelivery(id) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/news/startDelivery/${id}`, 'get')
        resolve(_result?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
}

class NewsReceiverService {
  updateOrCreate(id, data) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/newsReceiver/${id}`, 'put', data)
        resolve(_result?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  list(urlParams, page) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/newsReceiver?page=${page || 1}`, 'get', null, urlParams)
        resolve(_result?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
}

class NewsAttachmentService {
  upload(news_id, file) {
    return new Promise(async (resolve, reject) => {
      try {
        let formData = new FormData()
        formData.append('fileBlob', file)
        let _customHeaders = { 'Content-Type': 'multipart/form-data' }
        let _result = await request(`${API_BASE_URL}/newsAttachment/${news_id}?selected_group_id=${SELECTED_GROUP_ID}`, 'post', formData, null, _customHeaders)
        resolve(_result?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }
  delete(news_id, news_attachment_id) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/newsAttachment/${news_id}/${news_attachment_id}`, 'delete')
        resolve(_result?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }
  list(urlParams, page) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/newsAttachment?page=${page || 1}`, 'get', null, urlParams)
        resolve(_result?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
}

export const news = new NewsService()
export const newsReceiver = new NewsReceiverService()
export const newsAttachment = new NewsAttachmentService()
